<style lang="scss" scoped="">
  @import "../../../assets/scss/mixins";

  .content-part {
    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .batch-info {
    .oms-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right content-padding">
        <h3>上报库存详情</h3>
        <oms-row label="货主" :span="span">{{ currentItem.orgName }}</oms-row>
        <oms-row label="货品" :span="span">{{currentItem.goodsName }}</oms-row>
        <oms-row label="规格" :span="span">{{currentItem.specification }}</oms-row>
        <oms-row label="生产厂商" :span="span">{{ currentItem.factoryName }}</oms-row>
        <oms-row label="供货单位" :span="span" v-show="currentItem.supplyManufacturersName">{{
          currentItem.supplyManufacturersName }}
        </oms-row>
        <oms-row label="批号" :span="span">{{ currentItem.batchNumber }}</oms-row>
        <oms-row label="物流中心" :span="span" v-show="currentItem.logisticsCentreName">{{
          currentItem.logisticsCentreName}}
        </oms-row>
        <oms-row label="盘点数据" :span="span">{{ currentItem.count }}</oms-row>
        <oms-row label="创建时间" :span="span">{{ currentItem.createTime | time }}</oms-row>

        <h2 style="margin: 10px 0 0 0 ">调整记录</h2>
        <el-table :data="logList" class="header-list store border-black" border style="width: 100%">
          <el-table-column prop="count" label="盘点数量" :sortable="true" ></el-table-column>
          <el-table-column prop="createdByName" label="调整人" :sortable="true" ></el-table-column>
          <el-table-column prop="createTime" label="调整时间" :sortable="true" >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | time}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center mt-10" v-show="logList.length">
          <el-pagination :current-page="pager.currentPage" :page-size="20"
                         :page-sizes="[20,50,100]"
                         :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                         layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {BspInventory} from '@/resources';

  export default {
    props: ['currentItem', 'showDetailPart'],
    data() {
      return {
        span: 4,
        logList: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        },
        loading: false
      };
    },
    watch: {
      currentItem(val) {
        this.logList = [];
        if (!this.showDetailPart) return;
        if (!val || !val.id) return;
        this.queryStockDetail(1);
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.queryStockDetail(1);
      },
      handleCurrentChange(val) {
        this.queryStockDetail(val);
      },
      queryStockDetail(pageNo) {
        this.pager.currentPage = pageNo;
        let params = {
          stockBatchId: this.currentItem.id,
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        };
        BspInventory.queryLog(params).then(res => {
          this.logList = res.data.list;
          this.pager.count = res.data.count;
        }).catch(() => {
        });
      }
    }
  };
</script>
